import { Box, Input } from "arkh";
import React, { useCallback, useState } from "react";

import { useIntl } from "react-intl";
import { graphql, useLazyLoadQuery, useMutation } from "react-relay";
import { StoreEditNameScreenQuery } from "./__generated__/StoreEditNameScreenQuery.graphql";
import { LazyQueryNetworkBoundrary } from "../components/mobile/QueryNetworkBoundrary";
import { StoreAdminNavigationScreenProps } from "./StoreAdmin/StoreAdminNavigation";
import { useNavigationHeader } from "../common/navigationHeaderOptions";

export const StoreEditNameScreen = (
  props: StoreAdminNavigationScreenProps<"StoreEditName">
) => {
  return (
    <LazyQueryNetworkBoundrary>
      {(fk) => <StoreEditName {...props} fetchKey={fk} />}
    </LazyQueryNetworkBoundrary>
  );
};

function StoreEditName(
  props: StoreAdminNavigationScreenProps<"StoreEditName"> & {
    fetchKey: string;
  }
) {
  const intl = useIntl();
  const data = useLazyLoadQuery<StoreEditNameScreenQuery>(
    graphql`
      query StoreEditNameScreenQuery {
        store {
          name
        }
      }
    `,
    {},
    {
      fetchKey: props.fetchKey,
      fetchPolicy: "store-and-network",
    }
  );

  const [_name, setName] = useState<null | string>(null);

  if (_name && _name === data.store.name) {
    setName(null);
  }

  const name = _name === null ? data.store.name : _name;

  const [updateNameMutation, loading] = useMutation(graphql`
    mutation StoreEditNameScreenMutation($newName: String!) {
      store {
        updateName(name: $newName) {
          id
          name
        }
      }
    }
  `);

  const updateName = useCallback(() => {
    updateNameMutation({
      variables: { newName: name },
      onCompleted: () => {
        props.navigation.goBack();
      },
    });
  }, [name, props.navigation, updateNameMutation]);

  useNavigationHeader({
    type: "SAVE",
    onCancel: props.navigation.goBack,
    onSave: updateName,
    saveLoading: loading,
    title: intl.formatMessage({
      defaultMessage: "Edit store name",
      description: "StoreEditNameScreen header title",
    }),
    defaultContentStyle: true,
  });

  return (
    <Box
      spaceVertical="medium"
      spaceHorizontal="medium"
      style={{
        flex: 1,
      }}
    >
      <Input
        placeholder={intl.formatMessage({
          defaultMessage: "Store name",
          description: "StoreEditNameScreen name input placeholder",
        })}
        autoFocus
        value={name}
        returnKeyType="done"
        onChangeText={setName}
      />
    </Box>
  );
}
